import { useQuery } from '@tanstack/react-query';

import { listVoucherAutoAssignmentRules } from '~/services/PromoService';

import { voucherAutoAssignmentRuleQueryKeys } from './voucherAutoAssignmentRuleQueryKeys';

type Params = {
  query: Parameters<typeof listVoucherAutoAssignmentRules>[0];
  enabled?: boolean;
};

export function useListVoucherAutoAssignmentRules({ query, enabled = true }: Params) {
  return useQuery({
    queryKey: voucherAutoAssignmentRuleQueryKeys.list(query),
    queryFn: async ({ signal }) => listVoucherAutoAssignmentRules(query, { signal }),
    enabled,
  });
}
